<template>
  <v-dialog v-model="show" width="500">
    <v-card>
      <v-card-title>Copiar link de criação de conta</v-card-title>
      <v-card-text>
        <platform-selector
          label="Para qual plataforma?"
          v-model="platform"
          class="mb-4"
        />

        <v-alert v-if="platform" type="warning">
          <h6>Atenção!</h6>
          Esse link pertence ao cliente <b>{{ user.phone }}</b>
          <br />
          Só envie o link se o número for o mesmo do cliente.
        </v-alert>
        <v-checkbox
          v-model="confirm"
          label="Confirmo que o número do cliente é o mesmo informado acima."
        />
        <v-textarea
          v-if="link"
          v-model="link"
          label="Link"
          outlined
          dense
          hide-details
          disabled
          readonly
        />
        <v-btn
          color="primary"
          @click="copy"
          :disabled="!platform || successCopy"
          block
        >
          <v-icon v-if="successCopy" left>mdi-check</v-icon>
          <v-icon v-else left>mdi-content-copy</v-icon>
          {{ successCopy ? "Copiado!" : "Copiar" }}
        </v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import PlatformSelector from "@/components/global/PlatformSelector.vue";

export default {
  components: { PlatformSelector },
  props: {
    user: Object,
  },
  data() {
    return {
      show: false,
      platform: null,
      token: null,
      confirm: false,
      successCopy: false,
      link: null,
    };
  },
  methods: {
    open(token) {
      this.link = null;
      this.token = token;
      this.show = true;
      this.confirm = false;
    },
    copy() {
      const confirm =
        this.confirm ||
        window.confirm(
          `Confirme que o número do cliente é ${this.user.phone} antes de copiar o link.`
        );
      if (!confirm) return;
      const url = new URL(
        `https://${this.platform.domain}/auth/register?token=${this.token.id}`
      );
      this.link = `Olá, clique no link para criar sua conta\n${url.toString()}`;
      navigator.clipboard.writeText(this.link);
      this.successCopy = true;
      setTimeout(() => {
        this.successCopy = false;
      }, 3000);
    },
  },
  mounted() {
    this.$root.$on("copy_token", (token) => {
      this.open(token);
    });
  },
};
</script>
